import React from "react";
import { useLocation } from "react-router-dom";
import "./index.css";
import { BRAND_NAME } from "../branding";

const LoginLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className="login-layout">
      <main
        className={`login__mainContainer${
          isHomePage ? " login__mainContainer-home" : ""
        }`}
      >
        {children}
      </main>
      <footer className="login__footer">
        <p style={{ margin: "0", color: "white", fontSize: "12px" }}>
          &copy; 2026 {BRAND_NAME}. All Rights Reserved.
        </p>
      </footer>
    </div>
  );
};

export default LoginLayout;
